

export default angular.module("mars.vet.services.image",["ng"]).factory('ImageService', function($http, config) {
    'ngInject';
    var assetIDUrlCache = {};
    
    var contentful = config.contentful;

    return {
        getImageUrl: function(assetID) {
            if (assetIDUrlCache[assetID] === undefined) {
                var promise = $http.get(contentful.url + contentful.spaceid + '/assets/' + assetID + '?access_token=' + contentful.access_token, {
                    cache: true
                })
                assetIDUrlCache[assetID] = promise;
                return promise;
            } else {
                return assetIDUrlCache[assetID];
            }
        }
    };
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/image.service.js